import React, {useContext, useEffect, useState} from 'react'
import { getImages } from '../Const'
import { LeadsContext } from '../Context/LeadsContext'
import { useNavigate } from 'react-router-dom';

const AppointmentModal = ({ close,setAppointmentCount }) => {

    const {leadData, archiveLead,getLeads} = useContext(LeadsContext);
    const [appointments, setAppointments] = useState([]);
const navigate = useNavigate();
    const handleRadioChange = (lead, index, value) => {

        const newappointments = [...appointments];
        newappointments[index]['completed'] = value;
        setAppointments(newappointments);

        archiveLead(lead,true);
    };

    const removeComplete = () => {
        getLeads();

        return;
        
        const newappointments = [];

        appointments.map((v,i) => {
            if(!v.completed) newappointments.push(v);
        });

        setAppointments(newappointments);
    }

    useEffect(() => {
        var appointments = [];

        leadData.filter((lead) => lead.appointment_passed || lead.no_show).map((v,i) => {
            var this_appointment = v;
            v.completed = 0;
            appointments.push(this_appointment);
        });

        setAppointmentCount(appointments.length);
        setAppointments(appointments);
    },[leadData]);

    return (
        <>
            <div className="modal-header">
                <h1 className="modal-title text-uppercase" id="staticBackdropLabel">
                    NO SHOWS
                </h1>
                <button className="sm-box-close" type="button" onClick={close}>
                    <i className="fa-solid fa-xmark"></i>
                </button>
            </div>
            <div className="modal-body px-0">
                <div className='custom-table2 with-white-bg task-box'>
                    <table className='w-100'>
                        <thead>
                            <tr>
                                <th>Archive</th>
                                <th className='text-center'>Location</th>
                                <th className='text-center'>Date</th>
                                <th className='text-center'>Name</th>
                                <th className='text-center'>Vehicle Details</th>
                            </tr>
                        </thead>
                        <tbody >
                            {appointments && appointments.map((v,i) => {
                                const checked = v.completed != 0 && v.completed == 1;
                                return (
                                    <tr key={i}>
                                        <td>
                                            <label className="custom-checkbox">
                                                <input type="checkbox" id={`leadAppointment${i}`} checked={checked} value={checked ? "complete" : "incomplete"} onChange={(e) => {handleRadioChange(v, i, e.target.checked)}}/>
                                                <label htmlFor={`leadAppointment${i}`}></label>
                                            </label>
                                        </td>
                                        <td className='inv-title1 text-center dgray'
                                            style={{cursor: 'pointer'}}
                                            onClick={() => window.location.href = `/web?lead_id=${v.id}`}
                                        >{v.location}</td>
                                        <td className='inv-title1 text-center dgray'
                                            style={{cursor: 'pointer'}}
                                            onClick={() => window.location.href = `/web?lead_id=${v.id}`}
                                        >{v.appointment_str}</td>
                                        <td className='inv-title1 text-center dgray'
                                            style={{cursor: 'pointer'}}
                                            onClick={() => window.location.href = `/web?lead_id=${v.id}`}
                                        >{v.full_name}</td>
                                        <td className='inv-title1 text-center dgray'
                                            style={{cursor: 'pointer'}}
                                            onClick={() => window.location.href = `/web?lead_id=${v.id}`}
                                        >{v.vehicle_name}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                <div className='mt-4 d-flex align-items-center justify-content-between px-5'>
                    <div>
                        {/*<button className="text-nowrap blue-transparent-btn dark-transparent-btn text-uppercase py-2" type="button"><span className="blue-add-icon"></span> Add Appointment Reminder</button>*/}
                    </div>
                    <div>
                        <button className="blue-btn text-uppercase" type="button" onClick={(e) => {removeComplete();}}>Remove Complete</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AppointmentModal